import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';
import MedicalServicesOutlinedIcon from '@mui/icons-material/MedicalServicesOutlined';
import SupportAgentOutlinedIcon from '@mui/icons-material/SupportAgentOutlined';
import WorkspacePremiumOutlinedIcon from '@mui/icons-material/WorkspacePremiumOutlined';
import { USER_ROLES, ROLE_DISPLAY_NAMES } from '../../../constants/userRoles';
import { getRoleDisplayName } from '../../../utils/RoleManager';

/** Ícone de cada papel na tela de usuários. */
export const ROLE_ICONS = Object.freeze({
  [USER_ROLES.COMPANY_OWNER]: WorkspacePremiumOutlinedIcon,
  [USER_ROLES.COMPANY_ADMIN]: AdminPanelSettingsOutlinedIcon,
  [USER_ROLES.COMPANY_STAFF]: MedicalServicesOutlinedIcon,
  [USER_ROLES.COMPANY_SECRETARY]: SupportAgentOutlinedIcon,
});

/** Nome do papel vindo do banco, com o nome local de reserva. */
export const roleLabel = (role) => {
  const name = getRoleDisplayName(role);
  return name && name !== role ? name : (ROLE_DISPLAY_NAMES[role] || role);
};
